module.exports = __webpack_public_path__ + "static/CircularStd-Bold-b21525a9497949c3fdef65e444c50c0e.ttf";